import DeleteContainer from "./DeleteContainer";

export default DeleteContainer;
